import { ApiSchemaCaregiver } from "../models/api/caregiver";
import { Toggle, Modal, Form, Button, Loader } from "rsuite";
import { ApiCaregiver } from "../core/apis/caregiver";
import { useState, useEffect } from "react";
import { DateInput } from "./textInput.component";
import { addDays } from "date-fns";
import { ApiResponseContainer } from "../models/api";
import { useDispatch } from "react-redux";
import { ActionsCaregiverTable } from "../core/redux";

export const AutoClockToggle = ({
  value,
  caregiver,
}: {
  value: boolean;
  caregiver: ApiSchemaCaregiver;
}) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const [startDate, setStartDate] = useState<Date>();
  const [endDate, setEndDate] = useState<Date>();
  const handleClose = () => {
    setOpen(false);
    setStartDate(undefined);
    setEndDate(undefined);
  };

  const handleToggle = async () => {
    setIsLoading(true);
    let response: ApiResponseContainer<ApiSchemaCaregiver>;
    !value
      ? (response = await ApiCaregiver.ToggleAutoClockIn(
          caregiver,
          true,
          startDate,
          endDate
        ))
      : (response = await ApiCaregiver.ToggleAutoClockIn(caregiver, false));
    setIsLoading(false);
    handleClose();
    if (response.isSuccess) {
      dispatch(ActionsCaregiverTable.setRefetch(true));
    }
  };

  useEffect(() => {
    if (startDate && endDate && startDate >= endDate)
      setEndDate(addDays(startDate, 1));
  }, [endDate, startDate]);

  return (
    <>
      {isLoading ? (
        <Loader size="sm" />
      ) : (
        <Toggle
          size="sm"
          onChange={() => {
            !value ? handleOpen() : handleToggle();
          }}
          disabled={isLoading}
          checked={value}
        />
      )}
      <Modal open={open} onClose={handleClose}>
        <Modal.Header>
          <Modal.Title>
            Turn auto clock on for {caregiver.firstName} {caregiver.lastName}
          </Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleToggle}>
          <Modal.Body className="d-flex">
            <DateInput
              className="col-12"
              name="startDate"
              onChange={setStartDate}
              value={startDate}
            >
              Auto Clock Start Date
            </DateInput>
            <DateInput
              className="col-12"
              name="endDate"
              onChange={setEndDate}
              value={endDate}
              disabledDate={(date) =>
                !!date && !!startDate && date <= startDate
              }
            >
              Auto Clock End Date
            </DateInput>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="submit"
              disabled={!startDate || !endDate}
              loading={isLoading}
              appearance="primary"
            >
              Ok
            </Button>
            <Button
              onClick={handleClose}
              disabled={isLoading}
              type="reset"
              appearance="subtle"
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};
